import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { ChatState } from "../../ChatApp/Context/ChatProvider";
import Button1 from "../ResubleComp/Button";
const StartPost = ({ width, clickHandler, userImage, token }) => {
  const { user } = ChatState();
  return (
    <>
      <div className="rounded-md mt-12 sm:mt-2 md:mt-2 lg:mt-2 p-1 flex gap-3 border-2 border-blue-600">
        {user ? (
          <img
            src={user.userProfileImageUrl}
            className="rounded-full"
            style={{
              height: width > 768 ? "56px" : "40px",
              width: width > 768 ? "56px" : "40px",
            }}
            alt=""
          />
        ) : (
          <span>
            <AccountCircleIcon
              sx={{
                height: width > 768 ? "56px" : "40px",
                width: width > 768 ? "56px" : "40px",
              }}
            />
          </span>
        )}

        <Button1
          className="cursor-pointer w-full rounded-md font-medium bg-blue-500 text-white"
          sx={{
            color: "black",
            width: "70vw",
            borderRadius: "50px",
            fontSize: width > 768 ? "20px" : "13px",
            display: "flex",
            justifyContent: "Center",
            alignItems: "center",
            textTransform: width > 768 ? "uppercase" : "lowercase",
          }}
          onClick={clickHandler}
        >
          Click to Start a Post
        </Button1>
      </div>
    </>
  );
};
export default StartPost;
